"use strict";
var React = require("react");
var Modal = require("react-bootstrap").Modal;
var closeButton = require("react-bootstrap").closeButton;
var Button = require("react-bootstrap").Button;
var ButtonToolbar = require("react-bootstrap").ButtonToolbar;
var CompanyActions = require("../../../actions/CompanyActions");

var DeleteDepartmentModal = React.createClass({
    onSubmit(event) {
        this.props.onHide();
        event.preventDefault();
        CompanyActions.deleteDepartment(this.props.department.id);
    },
    render: function() {
        return (
            <Modal {...this.props} bsStyle="primary" animation={true}>
                <Modal.Body>
                    <div id="deleteDepartmentModal" className="modal-body">
                        <h3> Ertu viss um að þú viljir eyða: {this.props.department.name}? </h3>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <ButtonToolbar>
                        <Button className="btn-danger" onClick={this.onSubmit} type="submit">Já</Button>
                        <Button onClick={this.props.onHide}>Nei</Button>
                    </ButtonToolbar>
                </Modal.Footer>
            </Modal>
        );
    }
});

module.exports = DeleteDepartmentModal;



// WEBPACK FOOTER //
// ./app/scripts/ui/Settings/Departments/DeleteDepartmentModal.js